import axios from "axios";
import api from "../API/interceptors";

const API_URL = process.env.REACT_APP_API_URL;

export const registerUser = async (
  email, password, userId, courseId, firstname, lastname
) => {
  console.log("registerUser: start");

  try {
    const response = await axios.post(
      API_URL + "/auth/local/register",
      {
        username: email,
        email,
        password,
        userId,
        courseId,
        firstname,
        lastname,
        userRole: "user",
      }
    );

    console.log("registerUser response:", response.data);

    if (response.data.jwt) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.log("registerUser: catch", error);

    const message =
      error.response?.data?.error?.message ??
      error.message ??
      "Błąd rejestracji";

    console.log("Błąd rejestracji:", message);

    throw error;
  }
};


export const registerAsGuest = async (
  email,
  password,
  firstname,
  lastname,
  userRole
) => {
  console.log("registerAsGuest: start");

  try {
    const response = await axios.post(
      API_URL + "/auth/local/register",
      {
        username: email,
        email,
        password,
        firstname,
        lastname,
        userRole,
      }
    );

    console.log("registerAsGuest response:", response.data);

    if (response.data.jwt) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }

    window.parent.postMessage("Success", "*");

    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.error?.message ??
      error.message ??
      "Wystąpił błąd podczas rejestracji.";

    console.error("registerAsGuest failed:", message);

    window.parent.postMessage("Fail", "*");

    throw error;
  }
};

// export const loginUser = async (username, password) => {
//   return axios
//     .post(API_URL + "/auth/local", {
//       identifier: username,
//       password: password,
//     })
//     .then((response) => {
//       if (response.data.jwt) {
//         localStorage.setItem("user", JSON.stringify(response.data));
//       }
//       return response.data;
//     });
// };

export const loginUser = async (username, password) => {
  const response = await axios.post(
    `${API_URL}/users-permissions/auth/local`,
    {
      identifier: username,
      password,
    },
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const updateUser = async (id, token, payload) => {
  // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return api
    .put(API_URL + `/users/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      profileImage: payload.profileImage,
      firstname: payload.firstname,
      lastname: payload.lastname,
      education: payload.education,
      typeOfEducation: payload.typeOfEducation,
      region: payload.region,
      phone: payload.phone,
    })
    .then((response) => {
      if (token) {
        localStorage.setItem(
          "user",
          JSON.stringify({ jwt: token, user: response.data })
        );
      }
      return { jwt: token, user: response.data };
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getMe = async (jwt) => {
  const response = await axios.get(
    `${API_URL}/users/me`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    }
  );

  return response.data;
};

// export const getUserGroups = async () => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   if (!user?.jwt) throw new Error("User not logged in");

//   const response = await axios.get(`${API_URL}/auth/my-groups`, {
//     headers: {
//       Authorization: `Bearer ${user.jwt}`,
//     },
//   });

//   return response.data;
// };

export const getUserGroups = async () => {
  const response = await api.get("/auth/my-groups");

  return response.data;
};

// Old version to update cv inside user profile

// export const updateUserResume = async (id, token, payload) => {
//   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   console.log("updateUserResume");
//   console.log(id, token, payload);
//   return axios
//     .put(API_URL + `/users/${id}`, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       resume: payload,
//     })
//     .then((response) => {
//       if (token) {
//         localStorage.setItem(
//           "resume",
//           JSON.stringify({ resume: response.data })
//         );
//       }
//       return { resume: response.data };
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const updateUserResume = async (id, token, payload) => {
  // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return api
    .put(API_URL + `/cvs/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    })
    .then((response) => {
      if (token) {
        localStorage.setItem(
          "resume",
          JSON.stringify({ resume: response.data })
        );
      }
      return { resume: response.data };
    })
    .catch((err) => {
      console.log(err);
    });
};

// export const changePassword = async (id, token, payload) => {
//   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//     console.log('change pass')
//     return axios
//     .post(API_URL + `/api/auth/reset-password`, {
//           code: payload.code,
//           password: payload.password,
//           passwordConfirmation: payload.passwordConfirmation,
//     })
//     .then((response) => {
//       if (token) {
//           localStorage.setItem("user", JSON.stringify({jwt: token, user: response.data}));
//         }
//       // console.log('wysłano', response.data)
//       return {jwt: token, user: response.data}
//     }).catch(err => {
//       console.log(err)
//     })
//   };

export const resetPassword = async (payload) => {
  return axios
    .post(API_URL + `/auth/reset-password`, {
      code: payload.code,
      password: payload.password,
      passwordConfirmation: payload.repeatPassword,
    })
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
    });
};

export const forgotPassword = async (email, thunkAPI) => {
  return axios
    .post(API_URL + `/auth/forgot-password`, {
      email: email,
    })
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
    });
};

// export const logoutUser = () => {
//   localStorage.removeItem("user");
//   sessionStorage.removeItem("certificates");
// };

export const refreshToken = async () => {
  const response = await axios.post(
    API_URL + "/auth/refresh",
    {},
    {
      withCredentials: true,
    }
  );

  return response.data;
};


export const logoutUser = async (jwt) => {
  try {
    await axios.post(
      API_URL + "/users-permissions/auth/logout",
      {},
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
  } finally {

    localStorage.removeItem("user");
    sessionStorage.removeItem("certificates");
  }
};
